import { Box, LinearProgress, Typography } from '@mui/material';

import { Location } from '../../../../dtos';

type AuslastungPercentProps = {
  readonly auslastung: Location['seminarrundenAuslastung'][number];
};

export const AuslastungPercent = ({ auslastung }: AuslastungPercentProps) => {
  const { geblockteTage, verfuegbareTage } = auslastung;
  const percent = geblockteTage === 0 ? 0 : Math.round((geblockteTage / verfuegbareTage) * 100);

  return (
    <Box id="location-cell" sx={{ px: 0.5, py: 1 }}>
      <LinearProgress variant="determinate" value={percent} />
      <Typography variant="labelLight">{percent}%</Typography>
    </Box>
  );
};
